export { default as StoreCategoryPage } from "./View";
